<app-select (ngModelChange)="changeEntity($event)" [ngModel]="rule.value">
  @for (option of options; track option) {
    <mat-option [value]="option.value">
      {{ option.name }}
    </mat-option>
  }
</app-select>
